export default __webpack_public_path__ + "static/media/img_2.d5906a11.png";